<script>
	import Image from '$lib/Components/Layout/Image/Image.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';

	import logos from './logos.jpg';
</script>

<Section backgroundColor={'grey-light'}>
	<h2>Indow Inserts Are Featured In:</h2>
	<Image src={logos} alt="Indow inserts are featured in: " />
	<p style="font-style: italic;">
		“Once you pop them in (no hardware required), you don't even notice them.
		It's the kind of ridiculously simple invention that you think must have been
		invented before.” -Popular Mechanics, <a
			href="https://www.popularmechanics.com/home/interior-projects/a22285/these-ingenious-window-inserts-will-slash-your-heating-bill/"
			target="_blank"
			rel="noreferrer"
			>These Ingenious Window Inserts Will Slash Your Heating Bill</a
		>
	</p>
</Section>
